import { Controller } from "@hotwired/stimulus"

// Opens/closes the "Duplicar Característica" modal. The target is picked from a
// single searchable "Car — Version — Motorization" list (name="model_id"), so
// no client-side cascade is needed — the server derives the target car from the
// chosen motorization.
export default class extends Controller {
  static targets = ["modal"]

  open(event) {
    if (event) event.preventDefault()
    if (this.hasModalTarget && typeof this.modalTarget.showModal === "function") {
      this.modalTarget.showModal()
    }
  }

  cancel(event) {
    if (event) event.preventDefault()
    if (this.hasModalTarget && typeof this.modalTarget.close === "function") {
      this.modalTarget.close()
    }
  }
}
